import React from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import theme from "../../styles/theme";

const ProvisionalMarkStyled = styled.sup`
  color: ${theme.colors.grey};
  font-size: 10px;
  text-decoration: underline;
  cursor: help;
  margin-left: 4px;
`;

const ProvisionalMark = ({ title = "Зміна рейтингу підвищена через калібрування" }) => {
  return (
    <Tooltip title={title} arrow placement="top">
      <ProvisionalMarkStyled>?</ProvisionalMarkStyled>
    </Tooltip>
  );
};

export default ProvisionalMark;
